import clsx from 'clsx';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Button } from '../../../../../packages';

import { useStyles } from './AppointmentGroupButton.styles';

const AppointmentGroupButton = ({ isPastAppointments, setIsPastAppointments }) => {
  const classes = useStyles();

  const setPastAppointments = () => {
    setIsPastAppointments(true);
  };

  const setCurrentAppointments = () => {
    setIsPastAppointments(false);
  };

  return (
    <ButtonGroup variant="outlined" aria-label="outlined button group">
      <Button
        className={clsx(classes.btnGroupIcon, { [classes.btnGroupIconActive]: !isPastAppointments })}
        onClick={setCurrentAppointments}
      >
        Current
      </Button>
      <Button
        className={clsx(classes.btnGroupIcon, { [classes.btnGroupIconActive]: isPastAppointments })}
        onClick={setPastAppointments}
      >
        Past
      </Button>
    </ButtonGroup>
  );
};

export default AppointmentGroupButton;
